/*
a wrapper for localStorage() that will store every key value in a serialized JSON string
this allows localStorage to hold string, booleans, numbers, nulls, objects, and arrays
if localStorage() is not available, it will use a standard object for storage
*/
let temp: {
    [key: string]: any
} = {};

const localStorageIsSupported = (() => {
    try {
        const testKey = '__some_random_key_you_are_not_going_to_use__';
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (error) {
        return false;
    }
})();
export default class Local {
    static clear = () => {
        if (localStorageIsSupported) {
            localStorage.clear();
        }
        // noinspection JSUndeclaredVariable
        temp = {};
    };

    static getItem = (itemName: string, defaultValue: any = '__noDefaultValueSupplied__') => {
        if (localStorageIsSupported) {
            const valueObject = JSON.parse(localStorage.getItem(itemName) || 'null');
            if (valueObject === null) {
                if (defaultValue !== '__noDefaultValueSupplied__') {
                    Local.setItem(itemName, defaultValue);
                    return defaultValue;
                }
                return null;
            }
            if (Object.prototype.hasOwnProperty.call(valueObject, 'value')) {
                if (valueObject.value === null && defaultValue !== '__noDefaultValueSupplied__') {
                    Local.setItem(itemName, defaultValue);
                    return defaultValue;
                }
                return valueObject.value;
            }
            return null;
        }
        if (Object.prototype.hasOwnProperty.call(temp, itemName)) {
            return temp[itemName];
        }
        if (defaultValue !== '__noDefaultValueSupplied__') {
            temp[itemName] = defaultValue;
            return defaultValue;
        }
        return null;
    };

    static removeItem = (itemName: string) => {
        if (localStorageIsSupported) {
            localStorage.removeItem(itemName);
        } else if (Object.prototype.hasOwnProperty.call(temp, itemName)) {
            delete temp[itemName];
        }
        return true;
    };

    static setItem = (itemName: string, itemValue: any) => {
        if (localStorageIsSupported) {
            const valueToBeSerialized = {value : itemValue};
            const serializedValue = JSON.stringify(valueToBeSerialized);
            localStorage.setItem(itemName, serializedValue);
        } else {
            temp[itemName] = itemValue;
        }
        return itemValue;
    };
}
